module.exports = __webpack_public_path__ + "media/03_【アプリ版】点検編_東日本.f64f1a6b.mp4";